const PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID

let initialized = false

/**
 * True when the inline snippet in index.html already loaded fbevents.js, ran
 * fbq('init') and sent the initial PageView before the app bundle executed.
 */
export function wasPixelBootstrappedFromHtml() {
  return typeof window !== 'undefined' && window.__WL_PIXEL_PAGEVIEW_SENT__ === true
}

/**
 * Fallback bootstrap. In production index.html injects the base snippet so the
 * pixel fires before the bundle loads; this only does work when that snippet
 * did not run (env var missing at build time, tests, unusual hosts).
 */
export function initMetaPixel() {
  if (initialized || !PIXEL_ID) return
  initialized = true

  if (typeof window !== 'undefined' && typeof window.fbq === 'function') return

  /* Meta Pixel base code */
  ;(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  window.fbq('init', PIXEL_ID)
}

/**
 * Fire a PageView. The pixel is a SPA-wide singleton, so this must be called
 * on every client-side route change (see MetaPixelPageView), not just on init.
 */
export function trackPageView() {
  if (!PIXEL_ID || typeof window === 'undefined' || typeof window.fbq !== 'function') return

  window.fbq('track', 'PageView')
}

function parseFee(fee) {
  if (!fee) return 0

  const currencyMatches = [...fee.matchAll(/(?:₹|Rs\.?)\s?([\d,.]+)/gi)]
  if (currencyMatches.length) {
    return Math.max(...currencyMatches.map(m => {
      const num = parseFloat(m[1].replace(/,/g, ''))
      return isNaN(num) ? 0 : num
    }))
  }

  const num = parseFloat(fee.replace(/[^0-9.]/g, ''))
  return isNaN(num) ? 0 : num
}

function canTrackEvent(event) {
  return PIXEL_ID && typeof window !== 'undefined' && typeof window.fbq === 'function' && event
}

function getEventPayload(event) {
  return {
    content_name: event.name,
    content_ids: [String(event.id)],
    content_type: 'product',
    value: parseFee(event.fee),
    currency: 'INR',
  }
}

export function trackViewContent(event) {
  if (!canTrackEvent(event)) return

  window.fbq('track', 'ViewContent', getEventPayload(event))
}

export function trackAddToCart(event) {
  if (!canTrackEvent(event)) return

  window.fbq('track', 'AddToCart', getEventPayload(event))
}

export function trackInitiateCheckout(event) {
  if (!canTrackEvent(event)) return

  window.fbq('track', 'InitiateCheckout', getEventPayload(event))
}

export function trackPurchase(event, registrationId) {
  if (!canTrackEvent(event)) return

  const payload = getEventPayload(event)
  if (registrationId) {
    window.fbq('track', 'Purchase', payload, { eventID: String(registrationId) })
    return
  }

  window.fbq('track', 'Purchase', payload)
}
